// src/context/SiteSettingsContext.tsx
import React, { createContext, useContext, useState, useEffect, ReactNode } from 'react';
import axios from 'axios';
type SiteSettings = {
  site_name: string;
  maintenance_mode: boolean;
  default_language: string;
  allow_user_registration: boolean;
  allow_user_subscription: boolean;
  frontend_log_level: number;
  backend_log_level: number;
  must_change_password: boolean;
  supplements_enabled: boolean;
  structured_templates_enabled?: boolean;
  multi_documentation_available?: boolean;
};

type SiteSettingsContextType = {
  settings: SiteSettings | null;
  loading: boolean;
  error: string | null;
  reload: () => Promise<void>;
};

const SiteSettingsContext = createContext<SiteSettingsContextType>({
  settings: null,
  loading: true,
  error: null,
  reload: async () => {},
});

export const SiteSettingsProvider = ({ children }: { children: ReactNode }) => {
  const [settings, setSettings] = useState<SiteSettings | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  const reload = async () => {
    try {
      const response = await axios.get('/api/apps/fetch-site-settings/');
      setSettings(response.data);
      setError(null);
    } catch (err) {
      setError('Fehler beim Laden der SiteSettings');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    reload();
  }, []);

  return (
    <SiteSettingsContext.Provider value={{ settings, loading, error, reload }}>
      {children}
    </SiteSettingsContext.Provider>
  );
};

export const useSiteSettings = () => useContext(SiteSettingsContext);
